class CreditsTable {
  // eslint-disable-next-line class-methods-use-this
  init() {
    const creditsTableElement = document.querySelector(".js-credits-table");

    if (creditsTableElement) {
      const expandTableToggle = creditsTableElement.querySelector(".js-credits-table-togle");

      expandTableToggle.addEventListener("click", function () {
        creditsTableElement.classList.toggle("m-credits-table--expanded");
      });
    }
  }
}

Domestika.creditsTable = new CreditsTable();

// Pre-init
Domestika.creditsTable.init();
